import { IconSet } from '@postscript/components';
import { FEATURE_KEYS } from 'components/billing/common/constants';
import { useShopperStatus } from 'hooks/useShopperStatus';
import { useMemo } from 'react';
import { NavMenuItem } from '../NavMenu';

// Preserve the date filters in the URL when navigating between data-insights pages
const getAnalyticsLink = (url: string) =>
  window.location.pathname.includes('/data-insights')
    ? `${url}${window.location.search}`
    : url;

export const useDataInsightsMenuItems = () => {
  const shopperStatusContext = useShopperStatus();

  return useMemo(
    (): NavMenuItem[] => [
      {
        id: 'data-insights',
        label: 'Data & Insights',
        icon: IconSet.Leaderboard,
        isLoading: shopperStatusContext.isLoading,
        ariaLabelledBy: 'nav-data-insights-title',
        subMenu: [
          {
            link: (): string => getAnalyticsLink(`/data-insights/messages`),
            label: 'Messages',
            id: 'data-insights-messages',
            entitlementKey: 'analytics::messages::view',
          },
          {
            link: (): string => getAnalyticsLink(`/data-insights/subscribers`),
            label: 'Subscribers',
            id: 'data-insights-subscribers',
            entitlementKey: 'analytics::subscribers::view',
          },
          {
            link: (): string => getAnalyticsLink(`/data-insights/ai`),
            label: 'Infinity Testing',
            id: 'data-insights-ai',
          },
          // TODO: Make this an entitlement check when we sort out the entitlements/FF issues
          ...(shopperStatusContext.hasShopperFeatureEnabled
            ? [
                {
                  link: (): string =>
                    getAnalyticsLink(`/data-insights/shopper`),
                  label: 'Shopper',
                  id: 'shopper-trends',
                },
              ]
            : []),
          {
            link: (): string => getAnalyticsLink(`/data-insights/popups`),
            label: 'Acquisitions',
            id: 'popups',
            gatedFeatureKey: FEATURE_KEYS.omni_trends,
            entitlementKey: 'analytics::trends::view',
          },
          {
            link: (): string => getAnalyticsLink(`/data-insights/sltv`),
            label: 'SLTV',
            id: 'sltv',
            gatedFeatureKey: FEATURE_KEYS.omni_trends,
            entitlementKey: 'analytics::trends::view',
          },
          {
            link: (): string =>
              getAnalyticsLink(`/data-insights/revenue-orders`),
            label: 'Revenue and Orders',
            id: 'revenue-orders',
            gatedFeatureKey: FEATURE_KEYS.omni_trends,
            entitlementKey: 'analytics::trends::view',
          },
          {
            link: '/account/reports',
            label: 'Reports',
            id: 'data-insights-reports',
            entitlementKey: 'analytics::reports::view',
          },
        ],
      },
    ],
    [shopperStatusContext],
  );
};
